import React, { useState, useEffect } from "react";
import withApi from "../../higherOrderComponents/withApi";
import {
  DataDefinitionList,
  Notification,
  ButtonOBSOLETED,
} from "../../../web.common";
import { DisplayGuid } from "../../items";
import ReactSelect from "react-select";

export const Relay = withApi(({ api, productId }) => {
  const [isEditing, doEdit] = useState(null);
  const [loadedData, setData] = useState(null);
  const [integrationId, setIntegrationId] = useState(null);
  const [rules, setRules] = useState(null);
  const [preselectedRules, setPreselectedRules] = useState(null);

  const formLabelStyle = {
    display: "table-cell",
    width: "50%",
    whiteSpace: "nowrap",
    fontWeight: "bold",
    verticalAlign: "top",
  };

  const formSpanStyle = {
    display: "table-cell",
  };

  const rowStyle = {
    display: "table",
    width: "100%",
    margin: "auto",
    marginBottom: "0",
  };

  const containerStyle = {
    width: "100%",
    margin: "auto",
    backgroundColor: "white",
    border: "1px solid #e5e5e5",
    padding: "1.2rem",
  };

  const textAreaStyle = {
    width: "100%",
  };

  const internalEmailBehaviourMappings = [
    { value: 0, label: "DontSend" },
    { value: 1, label: "SendOnInternalBooking" },
    { value: 2, label: "SendOnConciergeSuccess" },
    { value: 3, label: "SendOnExternalConfirmation" },
  ];

  const options = [
    { value: true, label: "true" },
    { value: false, label: "false" },
  ];

  const getType = (typeFlag) => {
    const result = internalEmailBehaviourMappings.find(
      (item) => item.value === typeFlag
    );
    if (result == null || result == undefined) {
      return "";
    }
    return result.label;
  };

  useEffect(() => {
    async function loadFromApi() {
      const integration = await api.integrations.getIntegrationByProductId(
        productId
      );

      setIntegrationId(integration.Id);
      const relay = await api.integrations.getRelay(integration.Id);
      setData(relay);

      const option = {
        filters: {
          orderBy: "Name",
          orderDirection: "desc",
          id: null,
          page: null,
          name: null,
          type: null,
          resultsPerPage: 9999,
        },
      };
      var response = await api.relayRules.searchRules(option);
      setRules(response.rules);

      if (relay.relatedRules != null) {
        setPreselectedRules(
          relay.relatedRules.map((rule) => ({
            value: rule.id,
            label: rule.name,
          }))
        );
      }
    }

    if (!loadedData) {
      loadFromApi();
    }
  }, []);

  if (loadedData === null) {
    return <React.Fragment>Loading...</React.Fragment>;
  }

  return (
    <>
      <h3>Relay</h3>
      {isEditing ? (
        <React.Fragment>
          <div style={containerStyle}>
            <div style={rowStyle}>
              <label for="forwardExternalEmailBooking" style={formLabelStyle}>
                Forward External Email Booking
              </label>
              <span style={formSpanStyle}>
                <ReactSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={
                    options.filter(
                      (x) => x.value === isEditing.forwardExternalEmailBooking
                    ) || ""
                  }
                  onChange={(selection) =>
                    doEdit({
                      ...isEditing,
                      forwardExternalEmailBooking:
                        console.log(selection.value) || selection.value,
                    })
                  }
                  options={options}
                ></ReactSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label
                for="forwardExternalEmailCancellation"
                style={formLabelStyle}
              >
                Forward External Email Cancellation
              </label>
              <span style={formSpanStyle}>
                <ReactSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={
                    options.filter(
                      (x) =>
                        x.value === isEditing.forwardExternalEmailCancellation
                    ) || ""
                  }
                  onChange={(selection) =>
                    doEdit({
                      ...isEditing,
                      forwardExternalEmailCancellation:
                        console.log(selection.value) || selection.value,
                    })
                  }
                  options={options}
                ></ReactSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="sendConfirmationToProvider" style={formLabelStyle}>
                Send Confirmation To Provider
              </label>
              <span style={formSpanStyle}>
                <ReactSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={
                    options.filter(
                      (x) => x.value === isEditing.sendConfirmationToProvider
                    ) || ""
                  }
                  onChange={(selection) =>
                    doEdit({
                      ...isEditing,
                      sendConfirmationToProvider:
                        console.log(selection.value) || selection.value,
                    })
                  }
                  options={options}
                ></ReactSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="fromBodyMatch" style={formLabelStyle}>
                From Body Match
              </label>
              <span style={formSpanStyle}>
                <input
                  name="fromBodyMatch"
                  id="fromBodyMatch"
                  placeholder="fromBodyMatch"
                  value={isEditing.fromBodyMatch}
                  onChange={({ target }) =>
                    doEdit({
                      ...isEditing,
                      fromBodyMatch: console.log(target.value) || target.value,
                    })
                  }
                />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="fromEmailMatch" style={formLabelStyle}>
                From Email Match
              </label>
              <span style={formSpanStyle}>
                <input
                  name="fromEmailMatch"
                  id="fromEmailMatch"
                  placeholder="fromEmailMatch"
                  value={isEditing.fromEmailMatch}
                  onChange={({ target }) =>
                    doEdit({
                      ...isEditing,
                      fromEmailMatch: console.log(target.value) || target.value,
                    })
                  }
                />
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="booking" style={formLabelStyle}>
                Booking
              </label>
              <span style={formSpanStyle}>
                <ReactSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={
                    internalEmailBehaviourMappings.filter(
                      (x) => x.value === isEditing.booking
                    ) || ""
                  }
                  onChange={(selection) =>
                    doEdit({
                      ...isEditing,
                      booking: console.log(selection.value) || selection.value,
                    })
                  }
                  options={internalEmailBehaviourMappings}
                ></ReactSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="cancellation" style={formLabelStyle}>
                Cancellation
              </label>
              <span style={formSpanStyle}>
                <ReactSelect
                  className="react-select-filters-section"
                  classNamePrefix="react-select-filters-section-prefix"
                  value={
                    internalEmailBehaviourMappings.filter(
                      (x) => x.value === isEditing.cancellation
                    ) || ""
                  }
                  onChange={(selection) =>
                    doEdit({
                      ...isEditing,
                      cancellation:
                        console.log(selection.value) || selection.value,
                    })
                  }
                  options={internalEmailBehaviourMappings}
                ></ReactSelect>
              </span>
            </div>
            <hr />
            <div style={rowStyle}>
              <label for="relatedRules" style={formLabelStyle}>
                Related Rules
              </label>
              <ReactSelect
                defaultValue={preselectedRules}
                isMulti
                name=""
                options={rules.map(({ id, name }) => ({
                  value: id,
                  label: name,
                }))}
                onChange={(selection) => {
                  const selectedRuleIds =
                    selection && selection.map((option) => option.value);

                  const selectedRules =
                    selection &&
                    rules.filter((rule) => selectedRuleIds.includes(rule.id));
                  doEdit({ ...isEditing, relatedRules: selectedRules || [] });
                }}
                className="basic-multi-select"
                classNamePrefix="select"
              />
            </div>
            <br />
            <br />
            <div
              style={{
                justifyContent: "center",
                display: "flex",
                gap: "1.5rem",
              }}
            >
              <ButtonOBSOLETED
                type="submit"
                buttonContent="Save"
                onClick={async () => {
                  await api.integrations.updateRelay(isEditing);
                  const relay = await api.integrations.getRelay(integrationId);
                  setPreselectedRules(
                    relay.relatedRules.map((rule) => ({
                      value: rule.id,
                      label: rule.name,
                    }))
                  );
                  setData(relay);
                  doEdit(null);
                }}
              />
              <ButtonOBSOLETED
                type="reset"
                buttonContent="Cancel"
                onClick={async () => {
                  doEdit(null);
                }}
              />
            </div>
          </div>
        </React.Fragment>
      ) : (
        <DataDefinitionList
          listData={{
            Id: loadedData.integrationId,
            ["Forward External Email Booking"]:
              loadedData.forwardExternalEmailBooking,
            ["Forward External Email Cancellation"]:
              loadedData.forwardExternalEmailCancellation,
            ["Send Confirmation To Provider"]:
              loadedData.sendConfirmationToProvider,
            ["From Body Match"]: loadedData.fromBodyMatch,
            ["From Email Match"]: loadedData.fromEmailMatch,
            ["Booking"]: getType(loadedData.booking),
            ["Cancellation"]: getType(loadedData.cancellation),
            ["Related Rules"]: (
              <>
                {loadedData.relatedRules != null
                  ? loadedData.relatedRules.map((rule) => {
                      return (
                        <>
                          {" "}
                          <span>{rule.name}</span> -{" "}
                          <DisplayGuid short baseAnchor={"../../../rule"}>
                            {rule.id}
                          </DisplayGuid>{" "}
                          <br />
                        </>
                      );
                    })
                  : ""}
              </>
            ),

            "": (
              <div>
                <br />
                <ButtonOBSOLETED
                  type="submit"
                  buttonContent="Edit"
                  onClick={() => {
                    doEdit(loadedData);
                  }}
                />
              </div>
            ),
          }}
          classNames={["detail-page-list"]}
        />
      )}
    </>
  );
});
